import type { ParamMatcher } from '@sveltejs/kit';
import { supportedLocales } from '$lib/i18n/initI18n.js';
import type { SupportedLocale } from '$lib/i18n/initI18n.js';

export const match: ParamMatcher = (param): param is SupportedLocale => {
    return supportedLocales.includes(param as SupportedLocale);
};
